import React, { useEffect, useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import { useSelector, useDispatch } from 'react-redux';
import {
	logout,
	setName,
	setLastName,
	setProfile,
	setRole,
	setUserId,
	setEmail,
	setUser,
	setTeamName,
} from '../../store/actions/authActions';
import { ReactComponent as Line } from '../../utils/assets/line.svg';
import { ReactComponent as OxiwearLogo } from '../../utils/assets/oxiwear_logo.svg';
import { ReactComponent as Selector } from '../../utils/assets/selector.svg';
import styles from './layout.module.css';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Fade from '@mui/material/Fade';
import { ReactComponent as PersonOutlineIcon } from '../../utils/assets/profile_account.svg';
import { ReactComponent as SortIcon } from '../../utils/assets/profile_admin_management.svg';
import { ReactComponent as SendOutlinedIcon } from '../../utils/assets/profile_support.svg';
import { ReactComponent as LogoutOutlinedIcon } from '../../utils/assets/profile_logout.svg';
import Avatar from '@mui/material/Avatar';
import AddUser from '../../components/UI/addUser/AddUser';
import { ReactComponent as PersonAddAltIcon } from '../../utils/assets/add users.svg';
import useAxiosPrivate from '../../utils/hooks/useAxiosPrivate';

// import lnpcLogo from '../../utils/assets/teams/lnpc.png';
// // import devLogo from '../../utils/assets/Whitelabling_white.png';
// import liquid from '../../utils/assets/teams/liquid.png';
// import stjohns from '../../utils/assets/teams/stjohns-logo.svg';
// import jhu from '../../utils/assets/teams/jhu_long.png';
// import cc from '../../utils/assets/teams/cc.png';
// import sayf from '../../utils/assets/teams/sayf.png';
// import aspetar from '../../utils/assets/teams/aspetar.jpeg';
import {
	// getDomainPrefix,
	// getNavLogoForDomain,
	// getLogoStyleForDomain,
} from '../../utils/config/domainConfig';

import { makeStyles } from '@material-ui/core/styles';
import LogOutModel from './logOutModal';
import SupportModal from './supportModal';
import AccountModal from '../../screens/settings/accountModal';
import ChnagePasswordModal from '../../screens/settings/changePassword/changePasswordModal';
import EmailChangeModal from '../../screens/settings/changeEmail/changeEmailModal';
import SuccessModal from '../../screens/settings/changePassword/successModal';
import SuccessEmailModal from '../../screens/settings/changeEmail/successEmailModal';
import NotificationModal from '../../screens/notification/notificationModal';
import AuthenticationModal from '../../screens/settings/authenticationFlow/authenticationModal';
import CoachManagementModal from '../../screens/settings/coachManagement/coachManagementModal';
import AuthenticationBeforeModal from '../../screens/settings/authenticationFlow/authenticationBeforeModal';
import SuccessEmailModalForAdmin from '../../screens/settings/changeEmail/successEmailModalForAdmin';
import SubscriptionMainModal from '../../screens/subscription/subscriptionmain';
import { useNavigate, useLocation } from 'react-router-dom';

const useStyles = makeStyles(() => ({
	menu: {
		'& .MuiPaper-root': {
			backgroundColor: '#313131',
			color: '#DADADA',
			borderRadius: 0,
			boxShadow: 'none',
			minWidth: 198,
		},
		'& .MuiMenuItem-root': {
			fontFamily: 'Poppins',
			fontSize: '14px',
			fontWeight: 400,
			padding: '10px',
			gap: '2px',
			justifyContent: 'flex-start',
			transition: 'background-color 225ms ease, opacity 225ms ease',
		},
		'& .MuiMenuItem-root:hover': {
			backgroundColor: 'rgba(255, 255, 255, 0.08)',
			fontWeight: 500,
			color: '#FFFFFF',
		},
		'& .MuiListItemIcon-root': {
			minWidth: 'auto',
			marginRight: 0,
			color: 'inherit',
		},
	},
}));

export default function ButtonAppBar() {
	let navigate = useNavigate();
	const location = useLocation();
	const axiosInstance = useAxiosPrivate();
	const classes = useStyles();
	const state = useSelector((state) => state.auth);
	const dispatch = useDispatch();
	const [opened, setOpened] = useState(false);
	const [openedAuthentication, setOpenAuthentication] = useState(false);
	const [openedAuthenticationBefore, setOpenAuthenticationBefore] =
		useState(false);
	const [openedSupport, setOpenedSupport] = useState(false);
	const [openedAccount, setOpenedAccount] = useState(false);
	const [openedPassword, setOpenedPassword] = useState(false);
	const [openedEmail, setOpenedEmail] = useState(false);
	const [success, setSuccess] = useState(false);
	const [successEmail, setSuccessEmail] = useState(false);
	const [coachManagement, setCoachManagement] = useState(false);
	// const [imageURL, setImageURL] = useState('');
	const [verificationID, setVerificationID] = useState('');
	const [successEmailForAdmin, setSuccessEmailForAdmin] = useState(false);
	const [openSubscriptionMainModal, setOpenSubscriptionMainModal] =
		useState(false);
	const [profileLoaded, setProfileLoaded] = useState(false);

	const handleLogout = () => {
		sessionStorage.removeItem('profileData');
		dispatch(logout());
		window.location.href = '/';
	};

	const playerDirect = () => {
		navigate('/patients');
	};
	const DashDirect = () => {
		navigate('/dashboard');
	};

	const UserDirect = () => {
		navigate('/users');
	};

	const TeamDirect = () => {
		navigate('/team');
	};

	const ReportDirect = () => {
		navigate('/reports');
	};

	const [anchorEl, setAnchorEl] = React.useState(null);
	const open = Boolean(anchorEl);
	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};
	
	// Set domain image URL (runs once on mount since domainUrl is constant)
	useEffect(() => {
		// setImageURL(getDomainPrefix(window.location.hostname));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	
	
	useEffect(() => {
		const loadProfile = async () => {
			if (profileLoaded) return; 

			const token = state.accessToken || sessionStorage.getItem('accessToken');
			if (!token) {
				console.warn('No access token, skipping profile load.');
				return;
			}

			// Check sessionStorage first
			const cachedProfile = sessionStorage.getItem('profileData');

			if (cachedProfile) {
				const parsed = JSON.parse(cachedProfile);
				dispatch(setUser(parsed));
				dispatch(setName(parsed.first_name));
				dispatch(setLastName(parsed.last_name));
				dispatch(setRole(parsed.role));
				dispatch(setProfile(parsed.avatar_url));
				dispatch(setUserId(parsed.id));
				dispatch(setEmail(parsed.email));
				dispatch(setTeamName(parsed.team?.name));
				setProfileLoaded(true);
				return;
			}

			if (!state.name || !state.email || !state.role) {
				const { data } = await axiosInstance.get('/user/profile');
				const profileData = data.data;

				dispatch(setUser(profileData));
				dispatch(setName(profileData.first_name));
				dispatch(setLastName(profileData.last_name));
				dispatch(setRole(profileData.role));
				dispatch(setProfile(profileData.avatar_url));
				dispatch(setUserId(profileData.id));
				dispatch(setEmail(profileData.email));
				dispatch(setTeamName(profileData.team?.name));
				// Save to sessionStorage
				sessionStorage.setItem('profileData', JSON.stringify(profileData));
			}

			setProfileLoaded(true); // Mark profile as loaded
		};

		loadProfile();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [state.accessToken]); 

	return (
		<Box sx={{ flexGrow: 1 }}>
			{state.accessToken &&
			!location.pathname.includes('/profile') &&
			!location.pathname.includes('/register') ? (
				<AppBar
					position="fixed"
					style={{
						backgroundColor: '#313131',
						height: '3.37rem',
					}}
				>
					<Toolbar
						disableGutters
						style={{
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center',
							padding: '0 3.43rem',
							cursor: 'pointer',
							minHeight: '3.37rem',
							height: '100%',
						}}
					>
						<div style={{ display: 'flex', alignItems: 'center' }} onClick={DashDirect}>
							<OxiwearLogo />
							<Line style={{ width: 40, height: 20}} />
							<p
								style={{
									
									fontFamily: 'Poppins',
									fontWeight: 500,
									fontSize: '20px',
									lineHeight: '30px',
									color: '#D8EBEC',
									whiteSpace: 'nowrap',
								}}
							>
								{state.teamName}
							</p>
						</div>
						<div style={{ display: 'flex', marginRight: '3rem' }}>
							<p
								className={
									location.pathname === '/dashboard' || location.pathname === '/dashboard/'
										? styles.para3
										: styles.para
								}
								onClick={DashDirect}
							>
								Dashboard
							</p>
							<p
								className={
									location.pathname === '/team' || location.pathname === '/team/'
										? styles.para3
										: styles.para
								}
								onClick={TeamDirect}
							>
								Admin
							</p> 
							<p
								className={
									location.pathname === '/patients' || location.pathname === '/patients/'
										? styles.para3
										: styles.para
								}
								onClick={playerDirect}
							>
								Devices
							</p>
							<p
								className={
									location.pathname === '/reports' || location.pathname === '/reports/'
										? styles.para3
										: styles.para
								}
								onClick={ReportDirect}
							>
								Report
							</p>
						</div>
						<div style={{ display: 'flex', alignItems: 'center' }}>
							<div
								className={
									location.pathname === '/users' || location.pathname === '/users/'
										? styles.navIconWrapperSelected
										: styles.navIconWrapper
								}
								style={{ margin: '0px 1.5rem' }}
							>
								<PersonAddAltIcon
									onClick={UserDirect}
									className={styles.navIcon}
								/>
							</div>
							<AddUser style={{ margin: '0px 1.5rem' }} />
							{/* <AddDevice/> */}
							<NotificationModal
								setOpenAuthentication={setOpenAuthenticationBefore}
								setOpenedAccount={setOpenedAccount}
							/>
							<div
								className={
									open
										? `${styles.profileTrigger} ${styles.profileTriggerActive}`
										: styles.profileTrigger
								}
								onClick={handleClick}
							>
								<Avatar
									alt={state.name}
									src={state.url}
									sx={{ width: 25, height: 25 }}
								/>
								<p
									className={
										open ? styles.para2Active : styles.para2
									}
								>
									{state.name}
								</p>
								<Selector
									className={
										open
											? styles.profileSelectorOpen
											: styles.profileSelector
									}
								/>
							</div>
							<Menu
								id="fade-menu"
								MenuListProps={{
									'aria-labelledby': 'fade-button',
								}}
								anchorEl={anchorEl}
								open={open}
								onClose={handleClose}
								TransitionComponent={Fade}
								TransitionProps={{ timeout: 225 }}
								className={classes.menu}
								anchorReference="anchorPosition"
								anchorPosition={{ top: 54, left: window.innerWidth }}
								transformOrigin={{
									vertical: 'top',
									horizontal: 'right',
								}}
								marginThreshold={0}
							>
								<MenuItem
									onClick={() => {
										handleClose();
										setOpenedAccount(true);
									}}
								>
									<ListItemIcon>
										<PersonOutlineIcon
											className={styles.profileMenuIcon}
										/>
									</ListItemIcon>
									Account
								</MenuItem>
								{state?.role !== 'COACH' ? (
									<MenuItem
										onClick={() => {
											handleClose();
											setCoachManagement(true);
										}}
									>
										<ListItemIcon>
											<SortIcon
												className={styles.profileMenuIcon}
											/>
										</ListItemIcon>
										Admin Management
									</MenuItem>
								) : null}
								<MenuItem
									onClick={() => {
										handleClose();
										setOpenedSupport(true);
									}}
								>
									<ListItemIcon>
										<SendOutlinedIcon
											className={styles.profileMenuIcon}
										/>
									</ListItemIcon>
									Support
								</MenuItem>
								<MenuItem
									onClick={() => {
										handleClose();
										setOpened(true);
									}}
								>
									<ListItemIcon>
										<LogoutOutlinedIcon
											className={styles.profileMenuIcon}
										/>
									</ListItemIcon>
									Log Out
								</MenuItem>
							</Menu>
							<LogOutModel
								setOpen={setOpened}
								open={opened}
								handleLogout={handleLogout}
							/>
							<SupportModal setOpen={setOpenedSupport} open={openedSupport} />
							<AccountModal
								setOpen={setOpenedAccount}
								open={openedAccount}
								setOpenedPassword={setOpenedPassword}
								setOpenAuthentication={setOpenAuthentication}
							/>
							<ChnagePasswordModal
								setOpen={setOpenedPassword}
								open={openedPassword}
								setOpenedAccount={setOpenedAccount}
								setSuccess={setSuccess}
							/>
							<SuccessModal
								setOpen={setSuccess}
								open={success}
								setOpenedPassword={setOpenedPassword}
							/>
							<EmailChangeModal
								setOpen={setOpenedEmail}
								open={openedEmail}
								setOpenAuthentication={setOpenAuthentication}
								setSuccessEmail={setSuccessEmail}
								verificationID={verificationID}
								setOpenAuthenticationBefore={setOpenAuthenticationBefore}
							/>
							<SuccessEmailModal
								setOpen={setSuccessEmail}
								open={successEmail}
								setOpenedEmail={setOpenedEmail}
							/>
							<AuthenticationModal
								setOpen={setOpenAuthentication}
								open={openedAuthentication}
								setOpenedAccount={setOpenedAccount}
								setOpenedEmail={setOpenedEmail}
								setVerificationID={setVerificationID}
							/>

							<CoachManagementModal
								setOpen={setCoachManagement}
								open={coachManagement}
							/>
							<AuthenticationBeforeModal
								setOpen={setOpenAuthenticationBefore}
								open={openedAuthenticationBefore}
								setSuccessEmailForAdmin={setSuccessEmailForAdmin}
								setOpenedEmail={setOpenedEmail}
							/>
							<SuccessEmailModalForAdmin
								setOpen={setSuccessEmailForAdmin}
								open={successEmailForAdmin}
								setOpenAuthenticationBefore={setOpenAuthenticationBefore}
							/>
							<SubscriptionMainModal
								setOpen={setOpenSubscriptionMainModal}
								open={openSubscriptionMainModal}
							/>
						</div>
					</Toolbar>
				</AppBar>
			) : null}
		</Box>
	);
}
